import { Injectable } from '@angular/core';
import * as CryptoTS from 'crypto-ts';

@Injectable({
  providedIn: 'root'
})
export class EncryptDecryptService {

  constructor() { }
  tokenFromUI: string = "SadakSinghSherGill";
  encryptUsingAES256(data: any) {
    // Encrypt
    const ciphertext = CryptoTS.AES.encrypt(data,this.tokenFromUI);
    return ciphertext.toString();
 }
 decryptUsingAES256(data: any) {
   if (data === null) {
     return data;
   }
   const bytes  = CryptoTS.AES.decrypt(data,this.tokenFromUI);
   const plaintext = bytes.toString(CryptoTS.enc.Utf8);
   return plaintext;

 }
}
